<section class="card border mb-5">
  <form [formGroup]="form" (ngSubmit)="onFormSubmit()" #formRef="ngForm">
    <div class="card-body">
      <h3 class="mb-3">
        {{ 'competitionModule.blackListExplanationText' | translate }}
      </h3>

      <div class="btn-group mb-3">
        <!-- <div
          class="btn btn-soft-primary rounded"
          [ngClass]="{ active: !manualDateInput }"
        >
          <input
            class="form-check-input invisible"
            type="radio"
            value="wholeCompetition"
            formControlName="dateOption"
            (change)="onInputChange($event.currentTarget.value)"
            id="wholeCompetition2"
          />
          <label class="form-check-label" for="wholeCompetition2">{{
            'competitionModule.wholeCompetition' | translate
          }}</label>
        </div> -->

        <div
          class="btn btn-soft-primary"
          [ngClass]="{ active: manualDateInput }"
          hidden
        >
          <input
            class="form-check-input invisible"
            type="radio"
            value="dateRange"
            formControlName="dateOption"
            (change)="onInputChange($event.currentTarget.value)"
            id="dateOption2"
            aria-describedby="dateOption"
            [attr.aria-invalid]="
              form.controls.dateOption.dirty && form.controls.dateOption.invalid
                ? 'true'
                : null
            "
          />
          <label class="form-check-label" for="dateOption2">{{
            'competitionModule.specificDateRange' | translate
          }}</label>
        </div>
        <p
          id="dateOption"
          class="invalid-feedback"
          aria-atomic="true"
          role="alert"
          *ngIf="
            form.controls.dateOption.dirty && form.controls.dateOption.invalid
          "
        >
          {{ 'general.value' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>
      <fieldset class="mb-4" *ngIf="!manualDateInput">
        <legend class="form-label h5">
          {{ 'competitionModule.selectDays' | translate }}
        </legend>

        <ng-container
          *ngFor="let day of dayOptions$ | async; let i = index"
          formArrayName="days"
        >
          <div class="form-check" *ngIf="day.length">
            <input
              type="checkbox"
              [value]="i + 1"
              [formControlName]="i"
              [id]="'object2-' + i"
              class="form-check-input"
              (change)="changeSelectedBlackListOption(i, $event)"
              aria-describedby="formCheck"
              [attr.aria-invalid]="
                form.controls.days.dirty && form.controls.days.invalid
                  ? 'true'
                  : null
              "
            />
            <label class="form-check-label" [for]="'object2-' + i">
              {{ 'competitionModule.day' + i | translate }}
              {{ day[0] | roundedDate: '5' : true }} -
              {{ day[day.length - 1] | roundedDate: '5' : true }}</label
            >
          </div>
        </ng-container>
        <p
          class="invalid-feedback"
          aria-atomic="true"
          id="formCheck"
          role="alert"
          *ngIf="form.controls.days.dirty && form.controls.days.invalid"
        >
          {{ 'general.value' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </fieldset>

      <div *ngIf="manualDateInput">
        <div class="row g-2">
          <div class="col-md-6">
            <label class="form-label" id="startDateLabel">
              {{ 'general.startDate' | translate }}
            </label>

            <datetime-input
              formControlName="startDate"
              (ngModelChange)="dateChangeBlackList($event, 'startDate')"
              aria-labelledby="startDateLabel"
              [attr.aria-invalid]="
                form.controls.startDate.dirty && form.controls.startDate.invalid
                  ? 'true'
                  : null
              "
            ></datetime-input>
          </div>
          <div class="col-md-6">
            <label class="form-label me-auto" id="ednDateLabel">
              {{ 'general.endDate' | translate }}
            </label>

            <datetime-input
              formControlName="endDate"
              (ngModelChange)="dateChangeBlackList($event, 'endDate')"
              aria-labelledby="ednDateLabel"
              [attr.aria-invalid]="
                form.controls.endDate.dirty && form.controls.endDate.invalid
                  ? 'true'
                  : null
              "
            ></datetime-input>
          </div>
        </div>
      </div>

      <div class="d-flex py-3">
        <button
          class="btn btn-primary"
          type="submit"
          [disabled]="
            !form.dirty ||
            isDisabled ||
            (this.selectedBlackListDays$ | async)?.length ==
              (competitionEntities$ | async)[(team$ | async)?.competitionId]
                ?.maxBlacklist
          "
        >
          {{ 'general.add' | translate }}
        </button>
      </div>
      <div
        *ngIf="
          (competitionEntities$ | async)[(team$ | async)?.competitionId]
            ?.maxBlacklist > 0
        "
        class="fw-bold"
        [ngClass]="{
          'text-danger':
            (this.selectedBlackListDays$ | async)?.length >
            (competitionEntities$ | async)[(team$ | async)?.competitionId]
              ?.maxBlacklist
        }"
      >
        {{ 'general.youHaveUsed' | translate }}
        {{ (this.selectedBlackListDays$ | async)?.length }}
        {{ 'general.ofTheMaximum' | translate }}
        {{
          getMaxBlackList(
            (competitionEntities$ | async)[(team$ | async)?.competitionId]
              ?.maxBlacklist
          )
        }}
        {{ 'general.options' | translate }}
      </div>

      <div
        class="table-responsive mt-3"
        *ngIf="(selectedBlackListDays$ | async)?.length"
      >
        <table class="table table-borderless table-nowrap table-sm">
          <tbody>
            <tr *ngFor="let blacklistDay of selectedBlackListDays$ | async">
              <td colspan="10">
                <strong>
                  {{
                    blacklistDay.weekday == null
                      ? ('general.daily' | translate)
                      : ('competitionModule.day' + blacklistDay.weekday
                        | translate)
                  }}
                </strong>
              </td>
              <td>
                <span
                  *ngIf="
                    blacklistDay.startDate ==
                      (competitionEntities$ | async)[
                        (team$ | async)?.competitionId
                      ]?.startDate &&
                      blacklistDay.endDate ==
                        (competitionEntities$ | async)[
                          (team$ | async)?.competitionId
                        ]?.endDate;
                    else dateRange
                  "
                >
                  {{ 'competitionModule.wholeCompetition' | translate }}</span
                >

                <ng-template #dateRange>
                  {{
                    blacklistDay.startDate
                      | roundedDate: '15' : false
                      | formatDate: 'd MMM y HH:mm'
                      | async
                  }}
                  -
                  {{
                    blacklistDay.endDate
                      | roundedDate: '15' : false
                      | formatDate: 'd MMM y HH:mm'
                      | async
                  }}
                </ng-template>
              </td>
              <td>
                <button
                  (click)="onClickRemove(blacklistDay)"
                  class="btn btn-soft-primary btn-sm"
                  type="button"
                >
                  {{ 'general.remove' | translate }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </form>
</section>
